import React from "react"
import type { ReactNode } from "react"

export type CardsProps = {
  children?: ReactNode
}

function Cards({ children }: CardsProps) {
  return (
    <div className="flex flex-wrap -mx-2">
      {React.Children.map(children, (child, index) => (
        <div className="w-1/3 px-2 mb-4" key={index}>
          {child}
        </div>
      ))}
    </div>
  )
}

export default Cards
